import { tokens, serviceAlias } from './tokens';

function norm(input: string) {
  return input
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toUpperCase()
    .trim();
}

const serviceMap = new Map<string, keyof typeof tokens.service>(
  Object.keys(tokens.service).map((k) => [norm(k), k as keyof typeof tokens.service])
);

const qualityMap = new Map<string, keyof typeof tokens.quality>(
  Object.keys(tokens.quality).map((k) => [norm(k), k as keyof typeof tokens.quality])
);

export type ServiceKey = keyof typeof tokens.service;
export type QualityKey = keyof typeof tokens.quality;
export type MeasureKey = keyof typeof tokens.measure;

export function resolveService(name?: string): string {
  if (!name) return tokens.service['NEUTRO'];
  const n = norm(name);
  const aliasKey = (serviceAlias as any)[n] as ServiceKey | undefined;
  const key = aliasKey ?? serviceMap.get(n);
  return key ? tokens.service[key] : tokens.service['NEUTRO'];
}

export function resolveQuality(name?: string): string {
  if (!name) return tokens.quality.CLASSICO;
  const key = qualityMap.get(norm(name));
  return key ? (tokens.quality as any)[key] : tokens.quality.CLASSICO;
}

export function resolveMeasure(name?: MeasureKey): string {
  if (name && (tokens.measure as any)[name]) return (tokens.measure as any)[name];
  return tokens.measure.PEDIDO_MINIMO;
}
